import { render } from "./ActiveGetterTooltip.vue?vue&type=template&id=0b36be8d&scoped=true&ts=true"
import script from "./ActiveGetterTooltip.vue?vue&type=script&lang=ts"
export * from "./ActiveGetterTooltip.vue?vue&type=script&lang=ts"

import "./ActiveGetterTooltip.vue?vue&type=style&index=0&id=0b36be8d&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b36be8d"]])

export default __exports__